// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileHeader_wrapper__fiwt2","right":"MobileHeader_right__1W9vL"};